import focusedInboxRollupStore from '../store/store';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
/**
 * Update last visit timestamp for selected view and reset rollup data
 */
export default action('updateWatermarkAndResetRollup', datapoints.resetFocusedOtherRollupDatapoint)(function updateWatermarkAndResetRollup(focusedViewFilter, actionSource) {
    resetRollupData();
    updateFolderViewWatermark(focusedViewFilter);
});
/**
 * Update folder view watermark for focused/other folders
 * @param focusedViewFilter for which watermark is to be updated
 */
function updateFolderViewWatermark(focusedViewFilter) {
    var viewStateConfiguration = getUserConfiguration().ViewStateConfiguration;
    var currentTime = new Date(Date.now()).toUTCString();
    if (focusedViewFilter == 0 /* Focused */) {
        getUserConfiguration().ViewStateConfiguration.FocusedViewWatermark = currentTime;
        updateUserConfiguration('OWA.ViewStateConfiguration', [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: ['FocusedViewWatermark'],
                }),
                DictionaryValue: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: [viewStateConfiguration.FocusedViewWatermark],
                }),
            }),
        ]);
    }
    else if (focusedViewFilter == 1 /* Other */) {
        getUserConfiguration().ViewStateConfiguration.ClutterViewWatermark = currentTime;
        updateUserConfiguration('OWA.ViewStateConfiguration', [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: ['ClutterViewWatermark'],
                }),
                DictionaryValue: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: [viewStateConfiguration.ClutterViewWatermark],
                }),
            }),
        ]);
    }
}
/**
 * Reset rollup data in store
 */
function resetRollupData() {
    focusedInboxRollupStore.uniqueSenders = null;
    focusedInboxRollupStore.unseenCountToDisplay = null;
    focusedInboxRollupStore.viewType = 0 /* Invalid */;
}
//# sourceMappingURL=updateWatermarkAndResetRollup.js.map